export type Props = {
  src: string;
  type?: string;
} & Omit<React.ComponentProps<'video'>, 'src'>;

const AutoPlayVideo: React.FC<Props> = ({ src, type, ...rest }) => {
  return (
    <video autoPlay playsInline muted {...rest}>
      <source src={src} type={type} />
    </video>
  );
};

export default AutoPlayVideo;
